export const HEALTH_SCORE = "HEALTH_SCORE";
export const LIVE_ELEMENT_COUNT = "LIVE_ELEMENT_COUNT";
export const WIDGET_COUNT = "WIDGET_COUNT";
export const IMAGE_SIZE = "IMAGE_SIZE";
export const URL_LENGTH = "URL_LENGTH";
export const TITLE_LENGTH = "TITLE_LENGTH";
export const METADATA_LENGTH = "METADATA_LENGTH";
export const METADATA_TAGS = "METADATA_TAGS";
export const SOCIAL_TITLE = "SOCIAL_TITLE";
export const SOCIAL_DESCRIPTION = "SOCIAL_DESCRIPTION";
export const SOCIAL_IMAGE = "SOCIAL_IMAGE";
export const TWITTER_TITLE = "TWITTER_TITLE";
export const TWITTER_DESCRIPTION = "TWITTER_DESCRIPTION";
export const TWITTER_IMAGE = "TWITTER_IMAGE";
export const MISSING_ALT_TAGS = "MISSING_ALT_TAGS";
